import { DateTimeValueSchemas } from "@validereinc/utilities";
import { z } from "zod";
import {
  createExportListRequestSchema,
  createGetListRequestSchema,
} from "../util/index.ts";
import { AssetTypeSchema } from "./AssetSchemas.ts";
import { EquipmentSchema } from "./EquipmentSchemas.ts";
import { FacilitySchema } from "./FacilitySchemas.ts";

export const CalculatorResultGetListRequestSchema = createGetListRequestSchema(
  z
    .object({
      entity_type: AssetTypeSchema,
      entity_id: z.string().uuid(),
      year_month: DateTimeValueSchemas.dateYearMonth,
      reporting_group: z.string(),
      measurement_type: z.string(),
      "equipment.type.id": EquipmentSchema.shape.type.shape.id,
      "equipment.type.name": EquipmentSchema.shape.type.shape.name,
      "equipment.id": EquipmentSchema.shape.id,
      "equipment.name": EquipmentSchema.shape.name,
      "equipment.status": EquipmentSchema.shape.status,
      "equipment.facility.status": FacilitySchema.shape.status,
      "equipment.facility.id": FacilitySchema.shape.id,
      "equipment.facility.name": FacilitySchema.shape.name,
      "estimation_method.analytics_calculator_id": z.string(),
    })
    .partial(),
  z.object({
    isExcelFile: z.boolean().optional(),
  })
);
export type CalculatorResultGetListRequestType = z.infer<
  typeof CalculatorResultGetListRequestSchema
>;

export const CalculatorResultExportListRequestSchema =
  createExportListRequestSchema(
    CalculatorResultGetListRequestSchema.shape.filters.unwrap()
  );
export type CalculatorResultExportListRequestType = z.infer<
  typeof CalculatorResultExportListRequestSchema
>;
